import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Profile() {
    const navigate = useNavigate();
    const [profile, setProfile] = useState(null);
    const [bookings, setBookings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const res = await fetch("https://orisoftpl.com/backend/api/frontend/my-profile", {
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
                    },
                });

                if (res.status === 401) {
                    localStorage.removeItem("user_token");
                    localStorage.removeItem("user_data");
                    navigate("/login");
                    return;
                }

                const data = await res.json();
                setProfile(data.user);
                setBookings(data.allBookings);

            } catch (error) {
                setError("Something went wrong");
            } finally {
                setLoading(false);
            }
        };

        fetchProfile();
    }, []);

    if (loading) return (
        <div className="flex justify-center items-center py-20">
            <span className="loading loading-spinner loading-lg"></span>
        </div>
    );

    if (error) return (
        <p className="text-red-500 text-center py-10">{error}</p>
    );

    return (
        <div className="container mx-auto py-10 px-4">

            {/* Profile Card */}
            <div className="bg-white rounded shadow-lg p-6 mb-6">
                <h2 className="text-xl font-bold border-b pb-3 mb-4">My Profile</h2>
                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <p className="text-sm text-gray-500">Name</p>
                        <p className="font-semibold">{profile?.name}</p>
                    </div>
                    <div>
                        <p className="text-sm text-gray-500">Mobile</p>
                        <p className="font-semibold">{profile?.mobile_no}</p>
                    </div>
                    <div>
                        <p className="text-sm text-gray-500">Email</p>
                        <p className="font-semibold">{profile?.email || "—"}</p>
                    </div>
                    <div>
                        <p className="text-sm text-gray-500">Status</p>
                        <span className={`badge badge-${profile?.status_badge} badge-outline`}>
                            {profile?.status_label}
                        </span>
                    </div>
                </div>
            </div>

            {/* Bookings Table */}
            <div className="bg-white rounded shadow-lg p-6">
                <h2 className="text-xl font-bold border-b pb-3 mb-4">
                    My Bookings
                    <span className="text-sm font-normal text-gray-500 ml-2">
                        ({bookings.length} total)
                    </span>
                </h2>

                {bookings.length === 0 ? (
                    <p className="text-gray-500 text-center py-5">No bookings found</p>
                ) : (
                    <div className="overflow-x-auto">
                        <table className="w-full border">
                            <thead className="bg-gray-100">
                                <tr>
                                    <th className="border p-2 text-sm">Sl No.</th>
                                    <th className="border p-2 text-sm">Ref No.</th>
                                    <th className="border p-2 text-sm">Mandap</th>
                                    <th className="border p-2 text-sm">From</th>
                                    <th className="border p-2 text-sm">To</th>
                                    <th className="border p-2 text-sm">Price</th>
                                    <th className="border p-2 text-sm">Payment</th>
                                    <th className="border p-2 text-sm">Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {bookings.map((booking, index) => (
                                    <tr key={booking.id} className="border hover:bg-gray-50">
                                        <td className="border p-2 text-sm text-center">
                                            {index + 1}
                                        </td>
                                        <td className="border p-2 text-sm font-semibold text-blue-600">
                                            {booking.booking_ref || "—"}  {/* ✅ fixed */}
                                        </td>
                                        <td className="border p-2 text-sm">
                                            {booking.mandap?.name || "—"}
                                        </td>
                                        <td className="border p-2 text-sm">
                                            {booking.from_date}
                                        </td>
                                        <td className="border p-2 text-sm">
                                            {booking.to_date}
                                        </td>
                                        <td className="border p-2 text-sm">
                                            ₹{booking.price}
                                        </td>
                                        <td className="border p-2 text-sm">
                                            <span className={`badge badge-${booking.payment_badge} badge-outline`}>
                                                {booking.payment_label}
                                            </span>
                                        </td>
                                        <td className="border p-2 text-sm">
                                            <span className={`badge badge-${booking.status_badge} badge-outline`}>
                                                {booking.status_label}
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

        </div>
    );
}